import styled from 'styled-components';

export const TimelineBlockBox = styled.div`
  height: 100%;
  max-width: 800px;
  position: relative;
  transform: translateX(50px);
`;

export const TimelineBlockDot = styled.div`
  position: absolute;
  top: 0;
  left: 21px;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: var(--logo-orange); 
`;

export const TimelineBlockText = styled.div`
  display: inline-block;
  position: relative;  
  padding: 0 30px;
  line-height: 25px;
  text-align: left;
  .year {
    display: inline-block;
    position: absolute; 
    width: 100px;
    transform: translateX(-100%);
    font-size: 20px;
    font-weight: bold;
  }
`;

export const TimelineBlockEvents = styled.div`
  display: inline-block;  
  padding: 0 30px;
  padding-bottom: ${(props) => props.last ? "0" : "30px" };
  border-left: solid 3px var(--logo-gray);
  text-align: left;
`;